import type { AllRouteEndpoints } from "../routeTypes";
export const integrationsDirectCdiImportSyncsConnectionCacheKeys: AllRouteEndpoints[] = [];
